export default {
  deliveries: 'Lieferungen',
  freighter: 'Frächter',
  selectDialog: 'Lieferprogramm auswählen',
  selectFactoryDialog: 'Betrieb auswählen',
  deleteFactoryDialog: 'Betrieb löschen',
  accounting: "Verrechnung",
  complete: "Abgeschlossene",
  transactionAt: 'Überweisung am',
  discountFrom: 'Skonto von',
  additionalText: 'Zusatztext',
  note: {
    buyer: 'Kaüfer',
    seller: 'Verkäufer'
  },
  billing: {
    number: 'Nr.',
    article: 'Artikel',
    omCo: 'Omco',
    tattoo: 'Tat',
    nativity: 'Geb',
    fattening: 'Mast',
    netWeight: 'kg',
    phValue: 'PH',
    mfa: 'MFA',
    totalPerKg: 'LW kg',
    fixPerKg: 'LW Fix',
    total: 'LW Stk',
    remarks: 'Anmerkung',
    diagnosis: 'SFU',
    asTestPig: 'Als Testschwein'
  },
  notifications: {
    updateMasterdata: {
      type: 'success',
      message: 'Stammdaten Aktualisierung angefordert',
      title: 'Erfolgreich angefordert'
    },
    savedFreighter: {
      type: 'success',
      message: 'Frächter erfolgreich gespeichert',
      title: 'Erfolgreich angefordert'
    }
  }
}
